<div class="d-flex flex-column" [class.floating]="floating()" [class.regular]="!floating()">
  @if (!floating() && label()) {
    <label [for]="inputId()" class="form-label">
      {{ label() }}
      @if (_required()) {
        *
      }
    </label>
  }
  <div
    class="input-container"
    [class.form-floating]="floating()"
    [class.has-actions]="hasActions()"
    [class.has-prefix]="!!prefixIcon()">
    @if (prefixIcon()) {
      <div class="input-prefix">
        <custom-icon [name]="prefixIcon()!" viewBox="0 0 20 20" class="text-color" [size]="20" />
      </div>
    }

    <input
      #inputField
      [type]="inputType()"
      [ngModel]="_value()"
      [disabled]="_disabled()"
      [required]="_required()"
      [placeholder]="placeholder()"
      autocomplete="off"
      [id]="inputId()"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)"
      [class.is-invalid]="hasError()"
      class="form-control"
      [class.form-control-sm]="size() === 'sm'"
      [class.form-control-lg]="size() === 'lg'"
      [class.input-secondary]="secondary()" />

    @if (floating() && label()) {
      <label [for]="inputId()">
        {{ label() }}
        @if (_required()) {
          *
        }
      </label>
    }

    <div class="input-actions">
      @if (showClearButton()) {
        <button type="button" class="btn btn-sm btn-icon btn-icon-secondary" (click)="onClear()" tabindex="-1">
          <custom-icon name="clear" [size]="24" viewBox="0 0 24 24" />
        </button>
      }

      @if (showClearButton() && (isPasswordType() || suffixIcon())) {
        <span class="input-divider"></span>
      }

      @if (isPasswordType()) {
        <button type="button" class="btn btn-sm btn-icon btn-icon-secondary" (click)="toggleVisibility()" tabindex="-1">
          <custom-icon [name]="visibilityIcon()" [size]="24" viewBox="0 0 24 24" />
        </button>
      } @else if (suffixIcon()) {
        <button type="button" class="btn btn-sm btn-icon btn-icon-secondary">
          <custom-icon [name]="suffixIcon()!" [size]="24" />
        </button>
      }
    </div>
  </div>

  @if (errorMessage()) {
    <div class="invalid-feedback d-block">{{ errorMessage() }}</div>
  }
</div>
